module.exports = __webpack_public_path__ + "static/media/photo4.1a88a079.jpeg";